/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserGroup {
  SMES_USER = 'SMES:User',
  SMES_ADMIN = 'SMES:Admin',
  VICNAMES_ADMIN = 'VICNAMES:Admin',
  DQA_ADMIN = 'DQA:Admin',
  LASSI_ADMIN = 'LASSI:Admin',
}
